<template>
  <div v-if="courseShow" class="full-reduction-pop">
    <div class="contentPop">
      <img @click="onClose" class="closed" src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/closed.png" alt="" />
      <img class="success" src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/success.png" alt="" />
      <h3>激活成功！</h3>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    courseShow: Boolean,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    onClose() {
      this.$emit('courseChangeShow');
    },
  },
};
</script>
<style scoped lang="scss">
.full-reduction-pop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.3);

  .contentPop {
    position: relative;
    top: 50%;
    width: 592px;
    height: 308px;
    margin: 0 auto;
    padding-top: 80px;
    background: #fff;
    border-radius: 16px;
    transform: translateY(-50%);

    .closed {
      position: absolute;
      top: 30px;
      right: 30px;
    }

    .success {
      display: block;
      width: 96px;
      height: 96px;
      margin: 0 auto;
    }

    h3 {
      margin: 36px 0;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
      text-align: center;
    }

    .checkbtn {
      width: 324px;
      height: 76px;
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 32px;
      line-height: 76px;
      text-align: center;
      background: #ff7f41;
      border-radius: 50px;
    }
  }
}
</style>
